import React, { createContext, useContext, useState, useEffect } from "react";

interface NetworkStatusContextType {
  isOnline: boolean;
  setIsOnline: (online: boolean) => void;
}

const NetworkStatusContext = createContext<NetworkStatusContextType | undefined>(undefined);

export const NetworkStatusProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOnline, setIsOnline] = useState<boolean>(
    typeof navigator !== "undefined" ? navigator.onLine : true
  );

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <NetworkStatusContext.Provider value={{ isOnline, setIsOnline }}>
      {children}
    </NetworkStatusContext.Provider>
  );
};

export const useNetworkStatusContext = (): NetworkStatusContextType => {
  const context = useContext(NetworkStatusContext);
  if (context === undefined) {
    throw new Error("useNetworkStatusContext must be used within a NetworkStatusProvider");
  }
  return context;
};
